import React from "react";

const Brother = ({ house }) => {
  return (
    <div>
      <h4>Brother</h4>
      <p>
        <small>House: {house}</small>
      </p>
    </div>
  );
};

export default Brother;
